<main [class.full-screen]="isFullScreen">
  <app-header
    (toggleSidebar)="toggleSidebar()"
    [ngClass]="[showMinisidebar ? 'mini-sidebar' : '']">
  </app-header>
  <app-profile-overlay></app-profile-overlay>
  <div class="main-container">
    <app-nav-bar></app-nav-bar>
    <div
      id="router-wrapper"
      [ngClass]="[showMinisidebar ? 'mini-sidebar' : '']">
      <router-outlet></router-outlet>
    </div>
  </div>
  <xm-notification></xm-notification>
</main>
